import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeftIcon } from "./icons/FeatherIcons";

interface SwipeIndicatorProps {
  isVisible: boolean;
  direction: "left" | "right";
  progress: number; // 0 to 1
}

const SwipeIndicator: React.FC<SwipeIndicatorProps> = ({
  isVisible,
  direction,
  progress,
}) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed top-1/2 left-4 z-50 pointer-events-none"
        >
          <motion.div
            className="flex items-center justify-center w-12 h-12 bg-black/20 backdrop-blur-md rounded-full"
            animate={{
              scale: 0.8 + progress * 0.4,
              x: progress * 20,
            }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            <ArrowLeftIcon
              className={`w-6 h-6 text-white ${direction === "right" ? "rotate-180" : ""}`}
            />
          </motion.div>

          {/* Progress bar */}
          <motion.div
            className="absolute bottom-0 left-0 w-full h-1 bg-white/30 rounded-full overflow-hidden"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
          >
            <motion.div
              className="h-full bg-white rounded-full"
              style={{
                scaleX: progress,
                transformOrigin: "left",
              }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SwipeIndicator;
